module.exports = __webpack_public_path__ + "media/images/icons/material/compass-outline-19bee1d6605030eabe7b88799f0c0845.svg";